import { render, staticRenderFns } from "./studentLeaveNew.vue?vue&type=template&id=92f40ffa&scoped=true&"
import script from "./studentLeaveNew.vue?vue&type=script&lang=js&"
export * from "./studentLeaveNew.vue?vue&type=script&lang=js&"
import style0 from "./studentLeaveNew.vue?vue&type=style&index=0&id=92f40ffa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92f40ffa",
  null
  
)

export default component.exports